import { combineReducers } from 'redux';
import ZdwstStateVersionReducer from './ZdwstStateVersionReducer.js';
import AppMainPageReducer from './AppMainPageReducer.js';
import AppMainHeaderUrlReducer from './AppMainHeaderUrlReducer.js';
import AppMainHeaderTitleReducer from './AppMainHeaderTitleReducer.js';

export const finalReducer = combineReducers({
   ZdwstStateVersionReducer,
   AppMainPageReducer,
   AppMainHeaderTitleReducer,
   AppMainHeaderUrlReducer
});

